import { useTranslation } from 'react-i18next';
import { useApiMediasIdGet } from '@r/api/generated/client.ts';
import { FileUploader } from '@r/components/import/file-uploader.tsx';
import { getMediaIdFromIri } from '@r/helpers/widget-workspace-slides.ts';
import { getMediaUploadedFiles } from '@admin/pages/personalization/content-block-slides.ts';

interface ContentBlockMediaFieldProps {
  value: unknown;
  progresses: Record<string, number> | undefined;
  disabled: boolean;
  onValueChange: (files: File[]) => void;
  onRemove: () => void;
}

/** Résout l’IRI média et délègue l’upload au FileUploader partagé (ressources). */
export const ContentBlockMediaField = ({
  value,
  progresses,
  disabled,
  onValueChange,
  onRemove
}: ContentBlockMediaFieldProps) => {
  const { t } = useTranslation();
  const mediaId = getMediaIdFromIri(value);
  const mediaQuery = useApiMediasIdGet(mediaId);

  return (
    <div className="space-y-2">
      <FileUploader
        value={[]}
        onValueChange={(nextFiles) => {
          onValueChange(typeof nextFiles === 'function' ? nextFiles([]) : nextFiles);
        }}
        maxFiles={1}
        maxSize={2 * 1024 * 1024}
        progresses={progresses}
        disabled={disabled || mediaQuery.isLoading}
        uploadedFiles={getMediaUploadedFiles(value, mediaQuery.data?.pathUri)}
        onUploadedFileRemove={onRemove}
        accept={{ 'image/*': [] }}
      />
      <p className="text-[11px] leading-snug text-muted-foreground">
        {t('admin.contentblock.editor.media.formats')}
      </p>
    </div>
  );
};
